import { Component, Vue, Emit, Watch } from "vue-property-decorator";
import VueRouter, { RawLocation, Route } from "vue-router";
import LoadingAnimation from "@/components/loading/LoadingAnimation.vue";
import store from "@/store";

const Words: Dictionary = {
  error:
    "MGH Rewards Club会員メールアドレス<br>または会員パスワードに誤りがあります。",
  account: "メールアドレス",
  password: "パスワード",
  login: "登録する",
};

export interface ErrorType {
  title: string;
  message?: string;
}

@Component({
  components: {
    LoadingAnimation,
  },
})
export default class FormAlignmentMGHRWCBase extends Vue {
  protected words = Words;
  protected username = null;
  protected password = null;
  protected error: ErrorType | null = null;
  protected loading: boolean = false;
  protected showLoading: boolean = false;
  protected loadingTimerId: number | null = null;
  protected meta = this.$route.meta;
  protected lineAccessToken = this.meta ? this.meta.lineAccessToken : null;
  protected forgetMghrwcPwUrl = `${process.env.VUE_APP_MGHRWC_DOMAIN}${process.env.VUE_APP_MGHRWC_FORGET_PASSWORD_URL}`;
  protected signUpMghrwcUrl = `${process.env.VUE_APP_MGHRWC_DOMAIN}${process.env.VUE_APP_MGHRWC_CREATE_ACCOUNT_URL}`;
  get lang(): string {
    return store.getters["auth/lang"];
  }

  /** `from` クエリ（パス＋クエリ文字列）を正規化し、ガード差し替え時の push rejection を無視する */
  protected getNormalizedReturnLocation(): RawLocation {
    let from = this.$route.query.from;
    if (from && typeof from !== "string") {
      from = from[0] || "/";
    }
    const raw = (from as string) || "/";
    return this.$router.resolve(raw).location;
  }

  protected pushReturnDestination(): Promise<Route | void> {
    return this.$router.push(this.getNormalizedReturnLocation()).catch((err) => {
      if (VueRouter.isNavigationFailure(err)) {
        return;
      }
      throw err;
    });
  }

  @Watch("loading")
  protected onChagedLoading(newState: boolean) {
    if (this.loadingTimerId) {
      clearTimeout(this.loadingTimerId);
      this.loadingTimerId = null;
    }
    if (newState) {
      this.loadingTimerId = window.setTimeout(() => {
        this.showLoading = true;
        this.loadingTimerId = null;
      }, 3000);
    } else {
      this.showLoading = false;
    }
  }

  @Emit()
  protected handleSkip() {
    void this.pushReturnDestination();
  }

  @Emit()
  protected async onSubmit() {
    this.error = null;
    if (!this.username || !this.password) {
      this.error = {
        title:
          "MGH Rewards Club会員メールアドレス<br>または会員パスワードに誤りがあります。",
      };
      return;
    }

    try {
      this.loading = true;
      await store.dispatch("auth/mghrwcLogin", {
        mail: this.username,
        password: this.password,
      });
      await this.pushReturnDestination();
    } catch (e) {
      console.error(e);
      if (e.status === 403 || e.status === 400) {
        this.error = {
          title:
            "MGH Rewards Club会員メールアドレス<br>または会員パスワードに誤りがあります。",
        };
      } else {
        if (e.status === 500 && e.message === "MGHRWC connect Error") {
          this.error = {
            title: "システムエラー（OPTIMA接続エラー）",
            message:
              "予約システムへの接続が失敗しました。<br />お手数ですが、しばらく時間が経った後に、再度お試しをお願いします。",
          };
        } else {
          this.error = {
            title: "システムエラー",
            message:
              "サーバーからの応答が無いため処理を実行できませんでした。<br>お手数ですが、しばらく時間が経った後に、再度お試しをお願いします。",
          };
        }
      }
    } finally {
      this.loading = false;
    }
  }
}
